export const formatCreditCardNumber = (cardNumber: string): string => {
  const value = `${cardNumber}`.replace(/\D/g, '');
  const pattern = /^(34|37)/.test(value) ? 'XXXX XXXXXX XXXXX' : 'XXXX XXXX XXXX XXXX';
  let index = 0;

  return pattern.replace(/X/g, () => value.charAt(index++) || '').trim();
};
